module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[113]356.609956b.woff2";